<template>
    <div class="operationskalender">
        <div class="sidebar-div" :style="toggleSideBar === false ? 'display: none' : 'display: block'">
            <div class="close-sidebar-row">
                <img
                    class="close-sidebar-icon"
                    src="@/assets/close_grey.svg"
                    alt="close icon"
                    @click="toggleSideBar = !toggleSideBar"
                />
            </div>
            <div class="sidebar-section sidebar-title-row">
                <span class="sidebar-title">Filtrering</span>
                <hr class="sidebar-divider" />
            </div>
            <div class="sidebar-section sidebar-opsalar">
                <label class="filter-option">
                    <input
                        type="checkbox"
                        :checked="
                            currentFilterOption === FILTER_OPTION_OPSALAR && allFilterResourceOptionsAreShown(opsalar)
                        "
                        @change="toggleFilterOption(FILTER_OPTION_OPSALAR, $event)"
                    />
                    <div class="checkbox-frame">
                        <img class="checkmark-dark" src="@/assets/checkmark_dark.svg" />
                    </div>
                    <span class="section-title">Operationssal</span>
                </label>
                <hr class="sidebar-divider" />
                <template v-if="currentFilterOption === FILTER_OPTION_OPSALAR">
                    <label :key="sal.id" v-for="sal in opsalar" class="filter-resource-option">
                        <input type="checkbox" :checked="sal.show" @change="toggleShowResourceOption(sal)" />
                        <div class="checkbox-frame" :style="{ backgroundColor: sal.backgroundColor }">
                            <img class="checkmark-light" src="@/assets/checkmark_light.svg" />
                        </div>
                        <span class="checkbox-label">{{ sal.title }}</span>
                    </label>
                </template>
            </div>
            <div class="sidebar-section sidebar-operatorer">
                <label class="filter-option">
                    <input
                        type="checkbox"
                        :checked="
                            currentFilterOption === FILTER_OPTION_HUVUDOPERATORER &&
                            allFilterResourceOptionsAreShown(huvudoperatorer)
                        "
                        @change="toggleFilterOption(FILTER_OPTION_HUVUDOPERATORER, $event)"
                    />
                    <div class="checkbox-frame">
                        <img class="checkmark-dark" src="@/assets/checkmark_dark.svg" />
                    </div>
                    <span class="section-title">Operatör</span>
                </label>
                <hr class="sidebar-divider" />
                <template v-if="currentFilterOption === FILTER_OPTION_HUVUDOPERATORER">
                    <label :key="operator.pk" v-for="operator in huvudoperatorer" class="filter-resource-option">
                        <input type="checkbox" :checked="operator.show" @change="toggleShowResourceOption(operator)" />
                        <div class="checkbox-frame" :style="{ backgroundColor: operator.backgroundColor }">
                            <img class="checkmark-light" src="@/assets/checkmark_light.svg" />
                        </div>
                        <span class="checkbox-label">{{ operator.title }}</span>
                    </label>
                </template>
            </div>
            <div class="sidebar-section sidebar-lateralitet">
                <label class="filter-option">
                    <input
                        type="checkbox"
                        :checked="
                            currentFilterOption === FILTER_OPTION_LATERALITETER &&
                            allFilterResourceOptionsAreShown(lateraliteter)
                        "
                        @change="toggleFilterOption(FILTER_OPTION_LATERALITETER, $event)"
                    />
                    <div class="checkbox-frame">
                        <img class="checkmark-dark" src="@/assets/checkmark_dark.svg" />
                    </div>
                    <span class="section-title">Sida</span>
                </label>
                <hr class="sidebar-divider" />
                <template v-if="currentFilterOption === FILTER_OPTION_LATERALITETER">
                    <label :key="lat.id" v-for="lat in lateraliteter" class="filter-resource-option">
                        <input type="checkbox" :checked="lat.show" @change="toggleShowResourceOption(lat)" />
                        <div class="checkbox-frame" :style="{ backgroundColor: lat.backgroundColor }">
                            <img class="checkmark-light" src="@/assets/checkmark_light.svg" />
                        </div>
                        <span class="checkbox-label">{{ lat.title }}</span>
                    </label>
                </template>
            </div>
            <div class="sidebar-section sidebar-anestesier">
                <label class="filter-option">
                    <input
                        type="checkbox"
                        :checked="
                            currentFilterOption === FILTER_OPTION_ANESTESIER &&
                            allFilterResourceOptionsAreShown(anestesier)
                        "
                        @change="toggleFilterOption(FILTER_OPTION_ANESTESIER, $event)"
                    />
                    <div class="checkbox-frame">
                        <img class="checkmark-dark" src="@/assets/checkmark_dark.svg" />
                    </div>
                    <span class="section-title">Anestesi</span>
                </label>
                <hr class="sidebar-divider" />
                <template v-if="currentFilterOption === FILTER_OPTION_ANESTESIER">
                    <label :key="anestesi.id" v-for="anestesi in anestesier" class="filter-resource-option">
                        <input type="checkbox" :checked="anestesi.show" @change="toggleShowResourceOption(anestesi)" />
                        <div class="checkbox-frame" :style="{ backgroundColor: anestesi.backgroundColor }">
                            <img class="checkmark-light" src="@/assets/checkmark_light.svg" />
                        </div>
                        <span class="checkbox-label">{{ anestesi.title }}</span>
                    </label>
                </template>
            </div>
        </div>
        <div class="calendar-container" :style="toggleSideBar === false ? 'margin-left: 0px !important' : ''">
            <div class="page-wrapper">
                <div class="header-section">
                    <div class="header-and-info">
                        <span class="header-title">
                            <h2>Operationskalender</h2>
                            <img
                                class="info-img"
                                src="@/assets/union.svg"
                                alt="operation"
                                v-tooltip="{
                                    content:
                                        'Dra och släpp operationer från Operationskoordinering i en annan flik till',
                                }"
                            />
                        </span>
                        <h3 class="date-text">{{ getViewTitle }} {{ getWeekNumber }}</h3>
                    </div>

                    <div class="header-section-left">
                        <div class="k3-calendar-toolbar">
                            <div
                                class="filtrering-tab"
                                :class="{
                                    'active-item-month': toggleSideBar === true,
                                }"
                            >
                                <button
                                    class="tab-button-left"
                                    :class="{
                                        'active-tab': toggleSideBar,
                                    }"
                                    @click="toggleSideBar = !toggleSideBar"
                                >
                                    <img class="filter-img" src="@/assets/filter.svg" alt="operation" />
                                    <span>Filtrering</span>
                                </button>
                            </div>

                            <div v-if="canSparraTid" class="sparra-tid-tab">
                                <button
                                    class="tab-button-left"
                                    :class="{ 'active-tab': showSparraTid }"
                                    @click="sparraTid"
                                >
                                    <img class="sparra-tid-img" src="@/assets/block_time.svg" alt="operation" />
                                    <span>Spärra tid</span>
                                </button>
                            </div>

                            <div class="tidslinje-tab">
                                <button
                                    @click="timelineView"
                                    class="view-button"
                                    :class="{
                                        'active-tab': isTimelineView,
                                    }"
                                >
                                    <span class="opsal-text"> Tidslinje </span>
                                </button>
                            </div>

                            <div class="opsal-tab" :class="{ 'active-item-month': isResourceView }">
                                <button
                                    @click="opSalView"
                                    class="view-button"
                                    :class="{
                                        'active-tab': isResourceView,
                                    }"
                                >
                                    <span class="opsal-text"> Opsal </span>
                                </button>
                            </div>

                            <FormulateInput
                                class="calendar-view"
                                v-model="pickedViewOption"
                                name="calendar-view"
                                type="select"
                                placeholder="Välj vy"
                                @input="
                                    (viewId) => {
                                        if (viewId) {
                                            changeViewAndLoadData(viewId);
                                        }
                                    }
                                "
                                :options="viewOptions"
                            />

                            <div class="today-margins" :class="{ 'active-item-month': isToday }">
                                <button @click="today" class="view-button" :class="{ 'active-tab': isToday }">
                                    Idag
                                </button>
                            </div>

                            <FormulateInput
                                class="datepicker"
                                :clear-on-selection="true"
                                placeholder="Sök datum"
                                name="picked-time"
                                type="datepicker"
                                @input="
                                    (date) => {
                                        if (date) {
                                            goToDate(date);
                                        }
                                    }
                                "
                                @blur="leaveDatePicker"
                            />

                            <div class="arrow-buttons">
                                <div class="left-arrow-margins">
                                    <button class="arrow-button" @click="previous">
                                        <img src="@/assets/arrow_left_white.svg" alt="arrow-left" />
                                    </button>
                                </div>

                                <div class="right-arrow-margins">
                                    <button class="arrow-button" @click="next">
                                        <img src="@/assets/arrow_right_white.svg" alt="arrow-right" />
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="dagsinformation" v-if="isTimelineView || isResourceView || isDay">
                            <FormulateInput
                                type="checkbox"
                                label="Markera som klar"
                                v-model="planerad"
                                @change="savePlanerad"
                                :disabled="!canUpdateDagsinformation"
                            />
                            <hr />
                            <KButton variant="hollow" size="small" @click="showKommentera = !showKommentera">
                                <img v-if="dagsinformation?.kommentar" src="@/assets/comment_filled.svg" />
                                <img v-else src="@/assets/comment_empty.svg" />
                                <span> Kommentera</span>
                            </KButton>
                        </div>
                    </div>
                </div>
                <!-- TODO Stylingen behöver placeras på en bättre plats, vilket görs bättre i Vue3-branchen där all event-kod är utbruten i separata filer -->
                <div
                    ref="allDayEventsRef"
                    id="all-day-events"
                    v-if="isTimelineView && dayHasAllDayEvents"
                    class="calendar-info timeline-all-day-info"
                >
                    <p>Operationer utan tid</p>
                    <div>
                        <VMenu
                            v-for="event in allDayEvents"
                            :key="event.extendedProps.id"
                            :shown="hoveredAllDayEventId === event.extendedProps.id"
                            :triggers="[]"
                            placement="bottom-start"
                            :delay="{ show: 200, hide: 200 }"
                            :autoHide="false"
                        >
                            <div
                                :name="event.extendedProps.id"
                                :data-event="JSON.stringify(createEventData(event))"
                                class="fc-event all-day-activator"
                                :style="{
                                    cursor: 'grab',
                                    minWidth: '28px',
                                    maxWidth: event.extendedProps?.salstid
                                        ? (event.extendedProps.salstid / 60) * 60 + 'px'
                                        : 'none',
                                    width: 'auto',
                                }"
                                @mouseenter="hoveredAllDayEventId = event.extendedProps.id"
                                @mouseleave="hoveredAllDayEventId = null"
                            >
                                <div class="stripes-overlay" v-if="event.extendedProps.preliminarbokning"></div>
                                <div class="k3-custom-event-container timeline-event">
                                    <!-- TODO Upprepad kod. Det här är löst på ett bättre sätt i Vue3-branchen -->
                                    <div
                                        class="k3-custom-event-background"
                                        :style="{
                                            width: '100%',
                                            height: '1.8rem',
                                            display: 'grid',
                                            gridAutoFlow: 'column',
                                            backgroundColor: event.backgroundColor,
                                            gridTemplateColumns: `6px ${
                                                (event.extendedProps.forberedelser / event.extendedProps.salstid) * 100
                                            }% ${
                                                (event.extendedProps.optid / event.extendedProps.salstid) * 100
                                            }% auto`,
                                        }"
                                    >
                                        <div
                                            class="event-stripe"
                                            :style="{
                                                background: event.backgroundColor,
                                                position: 'unset',
                                            }"
                                        />
                                        <div
                                            class="k3-custom-event-forberedelser"
                                            :style="{
                                                backgroundColor: 'white',
                                                opacity: 0.8,
                                                height: '100%',
                                            }"
                                        />
                                        <div
                                            class="k3-custom-event-optid"
                                            :style="{
                                                backgroundColor: 'white',
                                                opacity: 0.6,
                                                height: '100%',
                                            }"
                                        />
                                        <div
                                            class="k3-custom-event-avveckling"
                                            :style="{
                                                backgroundColor: 'white',
                                                opacity: 0.8,
                                                height: '100%',
                                            }"
                                        />
                                    </div>
                                    <div
                                        class="k3-custom-event-info"
                                        :style="{
                                            color: event.textColor,
                                            position: 'absolute',
                                            width: '100%',
                                        }"
                                    >
                                        <div class="info-group">
                                            <span>{{
                                                event.extendedProps.huvudoperatorEjBestamd
                                                    ? "Ej bestämd"
                                                    : event.extendedProps.huvudoperator?.user_display?.username
                                            }}</span>
                                            <span>{{ event.extendedProps.opkod }}</span>
                                        </div>
                                        <span>{{ event.extendedProps.personId_formatted }}</span>
                                    </div>
                                </div>
                            </div>

                            <template #popper>
                                <CalendarToolTip
                                    :tip-border="event.backgroundColor"
                                    :dateBooked="event.extendedProps.startDateInSwedish"
                                    :salstid="!event.allDay ? formatSalstid(event.start, event.end) : null"
                                    :patient="`${event.extendedProps.personId_formatted} ${event.extendedProps.personNamn}`"
                                    :optid-tidpunkt-start="event.extendedProps.optidTidpunktStart"
                                    :optid="event.extendedProps.optid"
                                    :lateralitet="event.extendedProps.lateralitetDisplay"
                                    :huvudoperationkod="event.extendedProps.huvudoperation"
                                    :operatorer="event.extendedProps.operatorer"
                                    :operationsal="event.extendedProps.sal?.namn ?? ''"
                                    :resurskrockar="event.extendedProps.resurskrockar"
                                    :installelsedatum="event.extendedProps.installelsedatum"
                                    :installelsetid="event.extendedProps.installelsetid"
                                    :avtal="event.extendedProps.avtal"
                                    :anestesi="event.extendedProps.anestesiDisplay"
                                    :status="event.extendedProps.status"
                                    :preliminarbokning="event.extendedProps.preliminarbokning"
                                    :nivaer="event.extendedProps.nivaer"
                                    :implantat="event.extendedProps.implantat"
                                    :operationsinformation="event.extendedProps.operationsinformation"
                                >
                                    <template v-slot:inline-elements>
                                        <KButton
                                            type="button"
                                            variant="link"
                                            size="slim"
                                            @click="visaOperationsinformation(event)"
                                            :disabled="!canReadAnmalan"
                                        >
                                            Operationsinformation
                                        </KButton>
                                        <KButton
                                            v-if="event.extendedProps.aktuellPreanestesibedomning"
                                            type="button"
                                            variant="link"
                                            size="slim"
                                            @click="visaPreanestesibedomning(event)"
                                            :disabled="!canReadPeranestesibedomning"
                                        >
                                            Visa preanestesibedömning
                                        </KButton>
                                        <KButton
                                            type="button"
                                            variant="link"
                                            size="slim"
                                            @click="skapaKallelse(event)"
                                            :disabled="
                                                !canSkapaKallelse ||
                                                !(
                                                    event.extendedProps.status === 'Bokad' ||
                                                    event.extendedProps.preliminarbokning
                                                )
                                            "
                                        >
                                            Skapa kallelse
                                        </KButton>
                                        <div
                                            :style="{
                                                gridColumn: '1 / -1',
                                                display: 'grid',
                                                gridTemplateColumns: 'subgrid',
                                            }"
                                        >
                                            <KButton
                                                type="button"
                                                variant="link-without-icon"
                                                size="slim"
                                                @click="redigeraBokning(event)"
                                                :disabled="!canBokaOperation"
                                            >
                                                <img src="@/assets/edit.svg" alt="edit icon" />
                                                <span>Redigera bokning</span>
                                            </KButton>
                                            <KButton
                                                v-if="event.extendedProps.preliminarbokning"
                                                type="button"
                                                variant="link-without-icon"
                                                size="slim"
                                                @click="taBortPreliminarbokning(event)"
                                                :disabled="!canAvbokaOperation"
                                            >
                                                <img src="@/assets/calendar.svg" alt="calendar icon" />
                                                <span>Ta bort preliminärbokning</span>
                                            </KButton>
                                            <KButton
                                                v-else
                                                type="button"
                                                variant="link-without-icon"
                                                size="slim"
                                                @click="avbokaOperation(event)"
                                                :disabled="!canAvbokaOperation"
                                            >
                                                <img src="@/assets/calendar.svg" alt="calendar icon" />
                                                <span>Avboka operation</span>
                                            </KButton>
                                        </div>
                                    </template>
                                </CalendarToolTip>
                            </template>
                        </VMenu>
                    </div>
                </div>
                <FullCalendar :options="calendarOptions" ref="fullCalendar">
                    <template #resourceLabelContent="arg">
                        <div v-if="isTimelineView && arg.resource.id > 0" class="timeline-resource-wrapper">
                            <KButton
                                v-if="can({ action: 'update', subject: 'salsbemanning' })"
                                @click="openPersonalOchTider(arg.resource.extendedProps.salsbemanning)"
                                variant="none"
                                size="icon"
                                class="edit-salsbemanning"
                            >
                                <img :src="IconEditPen" />
                            </KButton>
                            <div class="resource-header">
                                <div
                                    class="resource-title"
                                    v-tooltip="{
                                        content: arg.resource.title,
                                        theme: 'kliniken-tooltip',
                                    }"
                                >
                                    {{ arg.resource.title }}
                                </div>
                            </div>
                            <div class="salsbemanning">
                                <div
                                    v-for="personal in arg.resource.extendedProps.salsbemanning.personal.filter(
                                        (personal) => personal.profile_display.roll_display.code === 'kirurg'
                                    )"
                                    :key="personal.id"
                                    class="box personal kirurg"
                                >
                                    <img :src="IconKirurg" class="personal-icon" />
                                    <div>
                                        <div class="personal-name">
                                            {{ personal.profile_display.user_display.name_short }}
                                        </div>
                                        <div class="personal-time">
                                            {{ getTime(personal.fran) }} -
                                            {{ getTime(personal.till) }}
                                        </div>
                                    </div>
                                </div>
                                <div
                                    v-if="arg.resource.extendedProps.salsbemanning.kommentar"
                                    v-tooltip="{
                                        content: arg.resource.extendedProps.salsbemanning.kommentar,
                                        theme: 'kliniken-tooltip',
                                    }"
                                    class="box salsbemanning-kommentar"
                                >
                                    {{ arg.resource.extendedProps.salsbemanning.kommentar }}
                                </div>
                            </div>
                        </div>
                        <div v-else>{{ arg.resource.title }}</div>
                    </template>
                    <template v-slot:eventContent="arg">
                        <template v-if="arg.event.extendedProps.sparradTid">
                            <template v-if="arg.view.type === 'dayGridMonth'">
                                <div class="sparrad-tid-info sparrad-tid-info-nano">
                                    <span>{{ formatStartTime(arg.event) }}</span>
                                    <span>{{ getKommentarOrOrsak(arg.event) }}</span>
                                </div>
                            </template>
                            <template
                                v-else-if="
                                    arg.event.extendedProps.duration < 75 || arg.view.type === 'resourceTimelineDay'
                                "
                            >
                                <div
                                    v-if="arg.view.type === 'resourceTimelineDay'"
                                    class="sparrad-tid-info sparrad-tid-info-timeline"
                                >
                                    <span>{{ getKommentarOrOrsak(arg.event) }}</span>
                                    <span>{{ arg.event.extendedProps.sal?.namn }}</span>
                                </div>
                                <div
                                    v-else
                                    class="sparrad-tid-info"
                                    :class="{
                                        'sparrad-tid-info-tiny': arg.event.extendedProps.duration < 31,
                                        'sparrad-tid-info-small': arg.event.extendedProps.duration >= 31,
                                    }"
                                >
                                    <span>{{ getKommentarOrOrsak(arg.event) }}</span>
                                    <span>{{ arg.event.extendedProps.sal?.namn }}</span>
                                </div>
                            </template>
                            <template v-else>
                                <div class="sparrad-tid-time-full">
                                    <span>{{ formatSalstid(arg.event.start, arg.event.end) }}</span>
                                </div>
                                <div class="sparrad-tid-info sparrad-tid-info-full">
                                    <span>{{ getKommentarOrOrsak(arg.event) }}</span>
                                    <span>{{ arg.event.extendedProps.sal?.namn }}</span>
                                </div>
                            </template>
                        </template>

                        <template v-else>
                            <VMenu
                                :shown="arg.event.extendedProps.showPopup"
                                placement="bottom-start"
                                :triggers="[]"
                                :delay="{ show: 200, hide: 200 }"
                                :auto-hide="true"
                            >
                                <!-- Tidslinjevy - visar användarnamn, opkod och personId -->
                                <div class="stripes-overlay" v-if="arg.event.extendedProps.preliminarbokning"></div>
                                <div
                                    v-if="arg.view.type === 'resourceTimelineDay' && !arg.event.allDay"
                                    class="k3-custom-event-container timeline-event"
                                    @mouseenter="arg.event.setExtendedProp('showPopup', true)"
                                    @mouseleave="arg.event.setExtendedProp('showPopup', false)"
                                    @mousedown="arg.event.setExtendedProp('showPopup', false)"
                                >
                                    <div class="k3-custom-event-info" :style="{ color: arg.event.textColor }">
                                        <div class="info-group">
                                            <span>
                                                {{
                                                    arg.event.extendedProps.huvudoperatorEjBestamd
                                                        ? "Ej bestämd"
                                                        : arg.event.extendedProps.huvudoperator?.user_display?.username
                                                }}
                                            </span>
                                            <span>{{ arg.event.extendedProps.opkod }}</span>
                                        </div>
                                        <span>{{ arg.event.extendedProps.personId_formatted }}</span>
                                        <span
                                            v-if="arg.event.extendedProps.resurskrockar?.length > 0"
                                            class="resource-error"
                                        >
                                            <img src="@/assets/warning-red.svg" />
                                        </span>
                                    </div>
                                    <div class="k3-custom-event-background">
                                        <div
                                            class="event-stripe"
                                            :style="{ background: arg.event.backgroundColor }"
                                        ></div>
                                        <div
                                            class="k3-custom-event-forberedelser"
                                            :style="{
                                                minWidth:
                                                    (arg.event.extendedProps.forberedelser /
                                                        arg.event.extendedProps.salstid) *
                                                        100 +
                                                    '%',
                                            }"
                                        ></div>
                                        <div
                                            class="k3-custom-event-optid"
                                            :style="{
                                                minWidth:
                                                    (arg.event.extendedProps.optid / arg.event.extendedProps.salstid) *
                                                        100 +
                                                    '%',
                                            }"
                                        ></div>
                                        <div
                                            class="k3-custom-event-avveckling"
                                            :style="{
                                                minWidth:
                                                    (arg.event.extendedProps.avveckling /
                                                        arg.event.extendedProps.salstid) *
                                                        100 +
                                                    '%',
                                            }"
                                        ></div>
                                    </div>
                                </div>
                                <!-- Månadsvyn - visar starttid och personnummer -->
                                <div
                                    v-else-if="arg.view.type === 'dayGridMonth'"
                                    class="k3-custom-event-container event-nano event-standard-pattern"
                                    :style="{ color: arg.event.textColor, background: arg.event.backgroundColor }"
                                >
                                    <div class="event-info-month">
                                        <span class="k3-custom-event-start">
                                            {{ formatStartTime(arg.event) }}
                                        </span>
                                        <span class="k3-custom-event-opkod">
                                            {{ arg.event.extendedProps.opkod }}
                                        </span>
                                        <span
                                            v-if="arg.event.extendedProps.resurskrockar?.length > 0"
                                            class="resource-error"
                                        >
                                            <img src="@/assets/warning-red.svg" />
                                        </span>
                                    </div>
                                    <div class="k3-custom-event-background">
                                        <div
                                            class="event-stripe"
                                            :style="{ background: arg.event.backgroundColor }"
                                        ></div>
                                        <div class="k3-custom-event-optid" :style="{ minHeight: '100%' }"></div>
                                    </div>
                                </div>
                                <!-- Övriga vyer - visar info beroende på storlek -->
                                <div
                                    v-else
                                    :class="{
                                        'k3-custom-event-container': true,
                                        'event-standard-pattern': true,
                                        'event-tiny': arg.event.extendedProps.salstid < 31 || arg.event.allDay,
                                    }"
                                >
                                    <div class="k3-custom-event-info" :style="{ color: arg.event.textColor }">
                                        <div
                                            v-if="arg.event.extendedProps.salstid >= 75 && !arg.event.allDay"
                                            class="k3-custom-event-time-user"
                                        >
                                            <span>
                                                {{ formatSalstid(arg.event.start, arg.event.end) }}
                                            </span>
                                            <span>
                                                {{
                                                    arg.event.extendedProps.huvudoperatorEjBestamd
                                                        ? "Ej bestämd"
                                                        : arg.event.extendedProps.huvudoperator?.user_display?.username
                                                }}
                                            </span>
                                        </div>
                                        <div
                                            v-if="arg.event.extendedProps.resurskrockar?.length > 0"
                                            class="resource-error"
                                        >
                                            <img src="@/assets/warning-red.svg" />
                                        </div>
                                        <div class="k3-custom-event-opkod-personid">
                                            <span class="k3-custom-event-opkod">
                                                {{ arg.event.extendedProps.opkod }}
                                            </span>
                                            <span class="k3-custom-event-personid">
                                                {{ arg.event.extendedProps.personId_formatted }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="k3-custom-event-background">
                                        <div
                                            v-if="arg.event.allDay"
                                            class="k3-custom-event-optid"
                                            :style="{ minHeight: '100%' }"
                                        ></div>
                                        <template v-else>
                                            <div
                                                class="k3-custom-event-forberedelser"
                                                :style="{
                                                    minHeight:
                                                        (arg.event.extendedProps.forberedelser /
                                                            arg.event.extendedProps.salstid) *
                                                            100 +
                                                        '%',
                                                }"
                                            ></div>
                                            <div
                                                class="k3-custom-event-optid"
                                                :style="{
                                                    minHeight:
                                                        (arg.event.extendedProps.optid /
                                                            arg.event.extendedProps.salstid) *
                                                            100 +
                                                        '%',
                                                }"
                                            ></div>
                                            <div
                                                class="k3-custom-event-avveckling"
                                                :style="{
                                                    minHeight:
                                                        (arg.event.extendedProps.avveckling /
                                                            arg.event.extendedProps.salstid) *
                                                            100 +
                                                        '%',
                                                }"
                                            ></div>
                                        </template>
                                    </div>
                                </div>
                                <template #popper>
                                    <CalendarToolTip
                                        :tip-border="arg.event.backgroundColor"
                                        :dateBooked="arg.event.extendedProps.startDateInSwedish"
                                        :salstid="
                                            !arg.event.allDay ? formatSalstid(arg.event.start, arg.event.end) : null
                                        "
                                        :patient="`${arg.event.extendedProps.personId_formatted} ${arg.event.extendedProps.personNamn}`"
                                        :optid-tidpunkt-start="arg.event.extendedProps.optidTidpunktStart"
                                        :optid="arg.event.extendedProps.optid"
                                        :lateralitet="arg.event.extendedProps.lateralitetDisplay"
                                        :huvudoperationkod="arg.event.extendedProps.huvudoperation"
                                        :operatorer="arg.event.extendedProps.operatorer"
                                        :operationsal="arg.event.extendedProps.sal?.namn ?? ''"
                                        :resurskrockar="arg.event.extendedProps.resurskrockar"
                                        :installelsedatum="arg.event.extendedProps.installelsedatum"
                                        :installelsetid="arg.event.extendedProps.installelsetid"
                                        :avtal="arg.event.extendedProps.avtal"
                                        :anestesi="arg.event.extendedProps.anestesiDisplay"
                                        :status="arg.event.extendedProps.status"
                                        :preliminarbokning="arg.event.extendedProps.preliminarbokning"
                                        :nivaer="arg.event.extendedProps.nivaer"
                                        :implantat="arg.event.extendedProps.implantat"
                                        :operationsinformation="arg.event.extendedProps.operationsinformation"
                                    >
                                        <template v-slot:inline-elements>
                                            <KButton
                                                type="button"
                                                variant="link"
                                                size="slim"
                                                @click="visaOperationsinformation(arg.event)"
                                                :disabled="!canReadAnmalan"
                                            >
                                                Operationsinformation
                                            </KButton>
                                            <KButton
                                                v-if="arg.event.extendedProps.aktuellPreanestesibedomning"
                                                type="button"
                                                variant="link"
                                                size="slim"
                                                @click="visaPreanestesibedomning(arg.event)"
                                                :disabled="!canReadPeranestesibedomning"
                                            >
                                                Visa preanestesibedömning
                                            </KButton>
                                            <KButton
                                                type="button"
                                                variant="link"
                                                size="slim"
                                                @click="skapaKallelse(arg.event)"
                                                :disabled="
                                                    !canSkapaKallelse ||
                                                    !(
                                                        arg.event.extendedProps.status === 'Bokad' ||
                                                        arg.event.extendedProps.preliminarbokning
                                                    )
                                                "
                                            >
                                                Skapa kallelse
                                            </KButton>
                                            <div
                                                :style="{
                                                    gridColumn: '1 / -1',
                                                    display: 'grid',
                                                    gridTemplateColumns: 'subgrid',
                                                }"
                                            >
                                                <KButton
                                                    type="button"
                                                    variant="link-without-icon"
                                                    size="slim"
                                                    @click="redigeraBokning(arg.event)"
                                                    :disabled="!canBokaOperation"
                                                >
                                                    <img src="@/assets/edit.svg" alt="edit icon" />
                                                    <span>Redigera bokning</span>
                                                </KButton>
                                                <KButton
                                                    v-if="arg.event.extendedProps.preliminarbokning"
                                                    type="button"
                                                    variant="link-without-icon"
                                                    size="slim"
                                                    @click="taBortPreliminarbokning(arg.event)"
                                                    :disabled="!canAvbokaOperation"
                                                >
                                                    <img src="@/assets/calendar.svg" alt="calendar icon" />
                                                    <span>Ta bort preliminärbokning</span>
                                                </KButton>
                                                <KButton
                                                    v-else
                                                    type="button"
                                                    variant="link-without-icon"
                                                    size="slim"
                                                    @click="avbokaOperation(arg.event)"
                                                    :disabled="!canAvbokaOperation"
                                                >
                                                    <img src="@/assets/calendar.svg" alt="calendar icon" />
                                                    <span>Avboka operation</span>
                                                </KButton>
                                            </div>
                                        </template>
                                    </CalendarToolTip>
                                </template>
                            </VMenu>
                        </template>
                    </template>
                </FullCalendar>
                <SparraTid
                    v-if="showSparraTid"
                    ref="sparraTid"
                    v-model="sparradTid"
                    @created="createSparradTidEvent"
                    @updated="updateSparradTidEvent"
                    @deleted="deleteSparradTidEvent"
                    @cancel="cancelSparraTid"
                />
                <Kommentera
                    v-if="showKommentera"
                    :value="dagsinformation?.kommentar"
                    @cancel="showKommentera = false"
                    @submit="submitKommentar"
                    :readonly="!canUpdateDagsinformation"
                />
                <PersonalOchTider
                    v-if="showPersonalOchTider"
                    @submitted="personalOchTiderSubmitted"
                    @close="closePersonalOchTider"
                    :salsbemanning="salsbemanning"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import { getConfig, getErrorMessage, klinikenApi } from "@/api";
    import "floating-vue/dist/style.css";
    import IconKirurg from "@/assets/bemanning_kirurg.svg";
    import IconEditPen from "@/assets/edit.svg";
    import tabIcon from "@/assets/operationskalender.svg";
    import KButton from "@/components/Button.vue";
    import CalendarToolTip from "@/components/CalendarToolTip.vue";
    import dialogEvents from "@/dialogEvents";
    import { formatMessage, nonFieldErrors } from "@/store/utils";
    import BaseTab from "@/tabs/mixins/BaseTab.js";
    import AvbokaOperation from "@/tabs/Operation/AvbokaOperation.vue";
    import BokaOperation from "@/tabs/Operation/BokaOperation.vue";
    import { mapActions, mapGetters, mapMutations } from "vuex";
    import {
        capitalizeFirstLetter,
        createEvent,
        createEventStyle,
        createSparradTidEvent,
        setEventInfo,
    } from "@/tabs/Operation/calendar-utils";
    import { BG_COLOR_NEUTRAL, eventColorScheme, TEXT_COLOR_NEUTRAL } from "@/tabs/Operation/colors-utils";
    import KallelseSend from "@/tabs/Operation/Kallelser/KallelseSend.vue";
    import Operationsanmalan from "@/tabs/Operation/Operationsanmalan.vue";
    import Operationsinformation from "@/tabs/Operation/Operationsinformation.vue";
    import PersonalOchTider from "@/tabs/Operation/PersonalOchTider.vue";
    import PreanestesibedomningVisa from "@/tabs/Operation/PreanestesibedomningVisa.vue";
    import {
        extractHourMinuteFromDateTime,
        fetchData,
        isNotEmptyArray,
        isNullOrUndefined,
    } from "@/tabs/Operation/utils";
    import { flashMessage, openDialog } from "@/utils";
    import svLocale from "@fullcalendar/core/locales/sv";
    import dayGridPlugin from "@fullcalendar/daygrid";
    import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
    import resourceTimeGridPlugin from "@fullcalendar/resource-timegrid";
    import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
    import timeGridPlugin from "@fullcalendar/timegrid";
    import FullCalendar from "@fullcalendar/vue";
    import moment from "moment";
    import emitter from "tiny-emitter/instance";
    import { ref, watch } from "vue";
    import Kommentera from "./Kommentera.vue";
    import SparraTid from "./SparraTid.vue";
    import { preliminarbokningLocked } from "@/tabs/Operation/utilsTs";

    const FILTER_OPTION_OPSALAR = "opsalar";
    const FILTER_OPTION_HUVUDOPERATORER = "huvudoperatorer";
    const FILTER_OPTION_LATERALITETER = "lateraliteter";
    const FILTER_OPTION_ANESTESIER = "anestesier";

    export default {
        extends: BaseTab,
        name: "Operationskalender",
        tabName: "Operationskalender",
        icon: tabIcon,
        refreshTab: true,
        components: {
            FullCalendar,
            CalendarToolTip,
            KButton,
            SparraTid,
            Kommentera,
            PersonalOchTider,
        },
        setup() {
            const allDayEventsRef = ref(null);
            const allDayEvents = ref([]);

            const setDraggable = () => {
                new Draggable(allDayEventsRef.value, {
                    itemSelector: ".fc-event",
                    appendTo: document.getElementById("all-day-events"),
                });
            };

            watch(allDayEventsRef, (newValue) => {
                if (newValue) {
                    setDraggable();
                }
            });

            return { allDayEvents, allDayEventsRef };
        },
        data() {
            return {
                pickedViewOption: null,
                hoveredAllDayEventId: null,
                viewOptions: [
                    {
                        value: "day-view",
                        label: "Dag",
                    },
                    {
                        value: "week-view",
                        label: "Vecka",
                    },
                    {
                        value: "weekend-view",
                        label: "Helg",
                    },
                ],
                viewLookup: {
                    "day-view": { view: "timeGridDay", hiddenDays: [] },
                    "week-view": { view: "timeGridWeek", hiddenDays: [0, 6] },
                    "weekend-view": { view: "timeGridWeek", hiddenDays: [1, 2, 3, 4, 5] },
                    "opsal-view": { view: "resourceTimeGridDay", hiddenDays: [] },
                    "timeline-view": { view: "resourceTimelineDay", hiddenDays: [] },
                },
                shown: false,
                toggleSideBar_: false,
                calendarApi: null,
                calendarOptions: {
                    eventAllow: (dropInfo) => {
                        if (dropInfo.allDay) {
                            return true;
                        }

                        // TODO Tidsbegränsningen bör hämtas från backend istället för att vara hårdkodat här
                        const startOfDay = moment(dropInfo.start).set({
                            hours: 7,
                            minutes: 0,
                        });
                        const endOfDay = moment(dropInfo.end).set({
                            hours: 19,
                            minutes: 0,
                        });

                        return (
                            moment(dropInfo.start).isSameOrAfter(startOfDay) &&
                            moment(dropInfo.end).isSameOrBefore(endOfDay)
                        );
                    },
                    plugins: [
                        dayGridPlugin,
                        timeGridPlugin,
                        interactionPlugin,
                        resourceTimeGridPlugin,
                        resourceTimelinePlugin,
                    ],
                    schedulerLicenseKey: import.meta.env.VITE_FULLCALENDAR_SCHEDULER_LICENSE_KEY || "",
                    initialView: "resourceTimelineDay",
                    locale: svLocale,
                    headerToolbar: false,
                    events: [],
                    droppable: true,
                    eventReceive: this.eventReceive,
                    editable: true,
                    eventDrop: this.eventDrop,
                    eventClick: this.eventClick,
                    weekends: true,
                    // TODO Tidsbegränsningen bör hämtas från backend istället för att vara hårdkodat här
                    slotMinTime: "07:00:00",
                    slotMaxTime: "19:00:00",
                    allDayClassNames: "all-day-cell",
                    allDayContent: "Operationer utan tid",
                    resourceOrder: "ordning,namn",
                    resources: [],
                    weekNumbers: true,
                    snapDuration: "00:05",
                    dateClick: this.dateClick,
                    resourceLabelClassNames: "resource-label-cell",
                    resourceLabelDidMount: this.resourceLabelDidMount,
                    resourceAreaHeaderContent: "Resurser",
                    eventResize: this.eventResize,
                    nowIndicator: true,
                    slotEventOverlap: false,
                    resourceAreaWidth: "26ch",
                    views: {
                        day: {
                            titleFormat: {
                                weekday: "long",
                                day: "numeric",
                                month: "long",
                                year: "numeric",
                            },
                        },
                    },
                },
                formatStartTime(event) {
                    if (!event.allDay) {
                        return moment(event.start).format("HH:mm");
                    } else {
                        return "";
                    }
                },
                sparradTid: null,
                showSparraTid: false,
                sparradTidEvent: null,
                eventColorScheme: [],
                opsalar: [],
                huvudoperatorer: [],
                lateraliteter: [
                    { id: 1, code: "HÖGER_SIDA", title: "Höger sida", show: true },
                    { id: 2, code: "VÄNSTER_SIDA", title: "Vänster sida", show: true },
                    { id: 3, code: "BILATERALT", title: "Bilateralt", show: true },
                    { id: 4, code: "EJ_AKTUELLT", title: "Ej aktuellt", show: true },
                ],
                anestesier: [],
                currentFilterOption: FILTER_OPTION_OPSALAR,
                dagsinformation: null,
                showKommentera: false,
                planerad: null,
                canReadOperationskalender: false,
                canReadAnmalan: false,
                canReadPeranestesibedomning: false,
                canBokaOperation: false,
                canAvbokaOperation: false,
                canUpdateDagsinformation: false,
                canSparraTid: false,
                canSkapaKallelse: false,
                FILTER_OPTION_OPSALAR: FILTER_OPTION_OPSALAR,
                FILTER_OPTION_HUVUDOPERATORER: FILTER_OPTION_HUVUDOPERATORER,
                FILTER_OPTION_LATERALITETER: FILTER_OPTION_LATERALITETER,
                FILTER_OPTION_ANESTESIER: FILTER_OPTION_ANESTESIER,
                getTime: extractHourMinuteFromDateTime,
                salsbemanningList: [],
                showPersonalOchTider: false,
                salsbemanning: null,
            };
        },
        computed: {
            ...mapGetters("opCalendar", ["getEvents", "getUnPlannedOperations", "getOperationSalar"]),
            ...mapGetters("operation/operationsanmalan", ["opAnmalans"]),
            ...mapGetters("ability", ["can"]),
            hasCalenderApi() {
                return this.calendarApi && this.calendarApi.currentData;
            },

            getViewTitle() {
                return this.hasCalenderApi ? capitalizeFirstLetter(this.calendarApi.currentData.viewTitle) : "";
            },

            getWeekNumber() {
                if (this.hasCalenderApi) {
                    const currentDate = this.calendarApi.currentData.currentDate;
                    return this.calendarApi ? `(vecka ${moment(currentDate).format("w")})` : "";
                }
                return "";
            },

            getViewDate() {
                return this.hasCalenderApi ? this.calendarApi.currentData.currentDate : "";
            },

            getCurrentViewType() {
                return this.hasCalenderApi ? this.calendarApi.currentData.currentViewType : "";
            },
            isToday() {
                if (this.getViewDate === "") {
                    return;
                }
                const date = new Date(this.getViewDate);
                const value = this.compareIsToday_(date);

                return (
                    ["timeGridDay", "resourceTimeGridDay", "resourceTimelineDay"].includes(this.getCurrentViewType) &&
                    value
                );
            },
            isWeek() {
                if (this.getCurrentViewType === "") {
                    return;
                }

                return this.getCurrentViewType === "timeGridWeek" || this.getCurrentViewType === "resourceTimeGridWeek";
            },
            isMonth() {
                if (this.getCurrentViewType === "") {
                    return;
                }

                return this.getCurrentViewType === "dayGridMonth";
            },
            isDay() {
                if (this.getCurrentViewType === "") {
                    return;
                }

                return this.getCurrentViewType === "timeGridDay" || this.getCurrentViewType === "resourceTimeGridDay";
            },
            isTimelineView() {
                if (this.getCurrentViewType === "") {
                    return;
                }

                return this.getCurrentViewType === "resourceTimelineDay";
            },
            isResourceView() {
                return (
                    this.getCurrentViewType === "resourceTimeGridDay" ||
                    this.getCurrentViewType === "resourceTimeGridWeek"
                );
            },
            dayHasAllDayEvents() {
                const eventsOfTheDay = this.calendarApi
                    .getEvents()
                    .filter(
                        (event) =>
                            moment(event.start).format("YYYY-MM-DD") ===
                            moment(this.calendarApi.getDate()).format("YYYY-MM-DD")
                    );
                const found = eventsOfTheDay.find((event) => event.allDay);
                return Boolean(found);
            },
            toggleSideBar: {
                get: function () {
                    return this.toggleSideBar_;
                },
                set: function (value) {
                    this.toggleSideBar_ = value;
                    setTimeout(() => {
                        this.calendarApi.updateSize();
                    }, 2);
                },
            },
            IconKirurg() {
                return IconKirurg;
            },
            IconEditPen() {
                return IconEditPen;
            },
        },
        methods: {
            ...mapMutations("operation/operationsanmalan", ["setOpAnmala"]),
            ...mapActions("operation/operationsanmalan", ["taBortPreliminarbokningById"]),
            toggleFilterOption(option, changeEvent) {
                if (this.currentFilterOption === option) {
                    // this[option] är ett dynamiskt sätt behandla de olika listorna som går att filtrera på, (this.opsalar,
                    // this.huvudoperatorer och this.lateraliteter). Strängen option behöver vara samma som namnet på listan.
                    this.toggleAllResourceOptions(this[option], changeEvent.target.checked);
                } else {
                    this.currentFilterOption = option;

                    // Visar alla events som dolts
                    this.resetFiltering();

                    // Ändrar färg på alla events enligt valt filteralternativ
                    const events = this.calendarApi.getEvents();
                    events.forEach((event) => {
                        if (!event.extendedProps.sparradTid) {
                            let colorId;

                            if (option === FILTER_OPTION_HUVUDOPERATORER) {
                                colorId = this.findColorIdOfHuvudoperator(event.extendedProps.huvudoperator.pk);
                            } else if (option === FILTER_OPTION_LATERALITETER) {
                                colorId = this.findColorIdOfLateralitet(event.extendedProps.lateralitet);
                            } else if (option === FILTER_OPTION_ANESTESIER) {
                                colorId = event.extendedProps.currentAnestesi?.id ?? 0;
                            } else {
                                colorId = event.extendedProps.sal?.id ?? 0;
                            }

                            const [backgroundColor, textColor] = createEventStyle(colorId);

                            event.setProp("backgroundColor", backgroundColor);
                            event.setProp("textColor", textColor);
                        }
                    });

                    this.allDayEvents = events.filter((event) => event.allDay);
                }
            },

            toggleAllResourceOptions(resourceList, checked) {
                resourceList.forEach((resource) => (resource.show = checked));

                const events = this.calendarApi.getEvents();

                events.forEach((event) => {
                    if (!event.extendedProps.sparradTid) {
                        if (checked) {
                            event.setProp(
                                "classNames",
                                event.classNames.filter((name) => name !== "hidden-event")
                            );
                        } else {
                            event.setProp("classNames", [...event.classNames, "hidden-event"]);
                        }
                    }
                });

                this.allDayEvents = events.filter(
                    (event) => event.allDay && !event.classNames.includes("hidden-event")
                );
            },

            findColorIdOfHuvudoperator(pk) {
                const huvudoperator = this.huvudoperatorer.find((o) => o.pk === pk);
                return huvudoperator?.id ?? 0;
            },

            findColorIdOfLateralitet(code) {
                const lateralitet = this.lateraliteter.findIndex((e) => e.code === code) + 1;
                return lateralitet ?? 0;
            },

            // Funktion för att ge en lista av resurser rätt färger
            // (Kan flyttas till calendar-utils)
            configureResourceGroupColors(resourceGroup) {
                resourceGroup.map((resource) => {
                    const [backgroundColor, textColor] = createEventStyle(resource.id);
                    resource.backgroundColor = backgroundColor;
                    resource.textColor = textColor;
                });
                return resourceGroup;
            },

            allFilterResourceOptionsAreShown(resourceList) {
                return resourceList.every((resource) => resource.show);
            },

            toggleShowResourceOption(resource) {
                resource.show = !resource.show;

                const events = this.calendarApi.getEvents();

                if (resource.show) {
                    // Visa event genom att ta bort class hidden-event

                    if (this.currentFilterOption === FILTER_OPTION_HUVUDOPERATORER) {
                        events.forEach((event) => {
                            if (
                                !event.extendedProps.sparradTid &&
                                event.extendedProps.huvudoperator.pk === resource.pk
                            ) {
                                event.setProp(
                                    "classNames",
                                    event.classNames.filter((name) => name !== "hidden-event")
                                );
                            }
                        });
                    } else if (this.currentFilterOption === FILTER_OPTION_LATERALITETER) {
                        events.forEach((event) => {
                            if (!event.extendedProps.sparradTid && event.extendedProps.lateralitet === resource.code) {
                                event.setProp(
                                    "classNames",
                                    event.classNames.filter((name) => name !== "hidden-event")
                                );
                            }
                        });
                    } else if (this.currentFilterOption === FILTER_OPTION_ANESTESIER) {
                        events.forEach((event) => {
                            if (
                                !event.extendedProps.sparradTid &&
                                event.extendedProps.currentAnestesi?.id === resource.id
                            ) {
                                event.setProp(
                                    "classNames",
                                    event.classNames.filter((name) => name !== "hidden-event")
                                );
                            }
                        });
                    } else {
                        events.forEach((event) => {
                            if (
                                !event.extendedProps.sparradTid &&
                                (event.extendedProps.sal?.id === resource.id ||
                                    (resource.id == 0 && !event.extendedProps.sal))
                            ) {
                                event.setProp(
                                    "classNames",
                                    event.classNames.filter((name) => name !== "hidden-event")
                                );
                            }
                        });
                    }
                } else {
                    // Dölj event med class hidden-event (kan bli dubbletter, kanske inte gör något?)

                    if (this.currentFilterOption === FILTER_OPTION_HUVUDOPERATORER) {
                        events.forEach((event) => {
                            if (
                                !event.extendedProps.sparradTid &&
                                event.extendedProps.huvudoperator.pk === resource.pk
                            ) {
                                event.setProp("classNames", [...event.classNames, "hidden-event"]);
                            }
                        });
                    } else if (this.currentFilterOption === FILTER_OPTION_LATERALITETER) {
                        events.forEach((event) => {
                            if (!event.extendedProps.sparradTid && event.extendedProps.lateralitet === resource.code) {
                                event.setProp("classNames", [...event.classNames, "hidden-event"]);
                            }
                        });
                    } else if (this.currentFilterOption === FILTER_OPTION_ANESTESIER) {
                        events.forEach((event) => {
                            if (
                                !event.extendedProps.sparradTid &&
                                event.extendedProps.currentAnestesi?.id === resource.id
                            ) {
                                event.setProp("classNames", [...event.classNames, "hidden-event"]);
                            }
                        });
                    } else {
                        events.forEach((event) => {
                            if (
                                !event.extendedProps.sparradTid &&
                                (event.extendedProps.sal?.id === resource.id ||
                                    (resource.id == 0 && !event.extendedProps.sal))
                            ) {
                                event.setProp("classNames", [...event.classNames, "hidden-event"]);
                            }
                        });
                    }
                }

                this.allDayEvents = events.filter(
                    (event) => event.allDay && !event.classNames.includes("hidden-event")
                );
            },

            resetFiltering() {
                this.opsalar.map((sal) => (sal.show = true));
                this.huvudoperatorer.map((operator) => (operator.show = true));
                this.lateraliteter.map((lateralitet) => (lateralitet.show = true));
                this.anestesier.map((anestesi) => (anestesi.show = true));

                const events = this.calendarApi.getEvents();

                events.forEach((event) => {
                    if (!event.extendedProps.sparradTid) {
                        event.setProp(
                            "classNames",
                            event.classNames.filter((name) => name !== "hidden-event")
                        );
                    }
                });

                this.allDayEvents = events.filter((event) => event.allDay);
            },

            resourceLabelDidMount(info) {
                let colorMark = document.createElement("div");
                colorMark.className = "color-mark";
                colorMark.style.backgroundColor = info.resource._resource.extendedProps.backgroundColor;
                info.el.childNodes[0].insertBefore(colorMark, info.el.childNodes[0].childNodes[0]);
            },

            // Callback-metod när en operation släpps från en tid i kalendern till en annan
            async eventDrop(eventDropInfo) {
                if (eventDropInfo.event.extendedProps.sparradTid) {
                    eventDropInfo.revert();
                    if (this.canSparraTid)
                        openDialog(
                            "För att flytta en spärrad tid behöver du klicka på den och fylla i formuläret.",
                            "warning"
                        );
                    return;
                }

                if (!this.canBokaOperation) {
                    eventDropInfo.revert();
                    openDialog(
                        "Du har inte tillåtelse att boka om operationen. Kontakta din enhetsadministratör om du har frågor om din användarprofil.",
                        "warning"
                    );
                    return;
                }

                let bokadOperationTid;
                if (!eventDropInfo.event.allDay) {
                    bokadOperationTid = eventDropInfo.event.extendedProps.forberedelser
                        ? moment(eventDropInfo.event.start)
                              .add(eventDropInfo.event.extendedProps.forberedelser, "minutes")
                              .format("HH:mm")
                        : moment(eventDropInfo.event.start).format("HH:mm");
                } else {
                    bokadOperationTid = null;
                }
                const payload = {
                    id: eventDropInfo.event.extendedProps.id,
                    bokad_operation_datum: moment(eventDropInfo.event.start).format("YYYY-MM-DD"),
                    bokad_operation_tid: bokadOperationTid,
                };

                if (eventDropInfo.newResource) {
                    payload.bokad_sal = eventDropInfo.newResource.id !== "0" ? eventDropInfo.newResource.id : null;
                }

                // Om jag bokar om till en annan dag - låt inställelsedatumet följa med
                const currentOpdatum = moment(eventDropInfo.oldEvent.start).format("YYYY-MM-DD");
                if (payload.bokad_operation_datum !== currentOpdatum) {
                    payload.installelsedatum = payload.bokad_operation_datum;
                }

                const newAnmalan = await this._bookOperationFromCalender(eventDropInfo, payload, true);
                await this.bytPatient(eventDropInfo?.event?.extendedProps.patientId ?? null);

                if (!isNullOrUndefined(newAnmalan)) {
                    const colorId = this.getColorId(newAnmalan);
                    setEventInfo(eventDropInfo.event, newAnmalan, colorId, true);
                    this.resetFiltering();
                }

                this.refreshResources();
            },

            // Callback-metod när en operation släpps från Operationskoordinering ELLER Operationer utan tid i Tidslinjen
            async eventReceive(info) {
                if (!this.canBokaOperation) {
                    info.revert();
                    openDialog(
                        "Du har inte tillåtelse att boka operationen. Kontakta din enhetsadministratör om du har frågor om din användarprofil.",
                        "warning"
                    );
                    return;
                }

                let bokadOperationTid;

                if (!info.event.allDay) {
                    const startDate = new Date(info.event.start);
                    startDate.setMinutes(startDate.getMinutes() + Number(info.event.extendedProps.forberedelser || 0));
                    bokadOperationTid = moment(startDate).format("HH:mm");
                } else {
                    bokadOperationTid = null;
                }

                const payload = {
                    id: info.event.id,
                    bokad_operation_datum: moment(info.event.start).format("YYYY-MM-DD"),
                    bokad_operation_tid: bokadOperationTid,
                    bokad_huvudoperator: info.event.extendedProps.huvudoperator?.pk,
                };

                if (!info.event.extendedProps.installelsedatum) {
                    payload.installelsedatum = payload.bokad_operation_datum;
                }

                const resources = info.event.getResources();

                if (resources.length) {
                    payload.bokad_sal = resources[0].id !== "0" ? resources[0].id : null;
                }

                const newAnmalan = await this._bookOperationFromCalender(info, payload, false);

                if (!isNullOrUndefined(newAnmalan)) {
                    const colorId = this.getColorId(newAnmalan);
                    setEventInfo(info.event, newAnmalan, colorId, false);
                    emitter.emit("operationsanmalan-bokad", newAnmalan);
                    this.resetFiltering();
                }
            },

            async _bookOperationFromCalender(info, payload, isUpdating) {
                try {
                    await klinikenApi.patch(`operation/anmalan/${payload.id}/boka/`, payload, getConfig());

                    // Hämtning görs efter patch, pga att /boka endpoint bara returnerar delar av anmälan
                    const { data } = await klinikenApi.get(`operation/anmalan/${payload.id}/`, getConfig());

                    if (data.preliminarbokning) {
                        flashMessage("Operationen preliminärbokad");
                    } else {
                        flashMessage(isUpdating ? "Bokningen uppdaterad" : "Operationen bokad");
                    }

                    const oldAnmalan = this.opAnmalans.find((item) => item.id === payload.id);
                    const newAnmalan = Object.assign({}, oldAnmalan, data);
                    this.setOpAnmala(newAnmalan);

                    return newAnmalan;
                } catch (error) {
                    const { non_field_errors, bokad_sal, retroaktiv_bokning } = error.response.data;
                    const { list: overbokningar } = nonFieldErrors(non_field_errors, "overbokningar");
                    const retroaktivBokningList = retroaktiv_bokning ? retroaktiv_bokning : [];
                    const errorOverbokningar = formatMessage(overbokningar, "overbokningar");
                    const errorRetroaktivBokning = formatMessage(retroaktivBokningList, "retroaktiv_bokning");
                    const errorList = [...errorOverbokningar, ...errorRetroaktivBokning];

                    if (errorList.length) {
                        return new Promise((resolve) => {
                            dialogEvents.$emit("open", {
                                type: "warning",
                                errorList: errorList,
                                description: "",
                                buttons: [
                                    {
                                        title: "Avbryt",
                                        type: "outline-primary",
                                        action: () => {
                                            info.revert();
                                            resolve(null);
                                        },
                                    },
                                    {
                                        title: "Gå vidare med bokning ändå",
                                        type: "primary",
                                        action: async () => {
                                            if (overbokningar.length) {
                                                payload.overboka = true;
                                            } else {
                                                payload.retroaktiv_bokning = true;
                                            }

                                            const newAnmalan = await this._bookOperationFromCalender(
                                                info,
                                                payload,
                                                isUpdating
                                            );
                                            resolve(newAnmalan ?? null);
                                        },
                                    },
                                ],
                            });
                        });
                    } else if (bokad_sal?.length) {
                        const errorList = formatMessage(bokad_sal, "bokad_sal");
                        return new Promise((resolve) => {
                            dialogEvents.$emit("open", {
                                type: "error",
                                errorList,
                                description: "",
                                buttons: [
                                    {
                                        title: "Avbryt",
                                        type: "outline-primary",
                                        action: () => {
                                            info.revert();
                                            resolve(null);
                                        },
                                    },
                                    {
                                        title: "Avbryt och redigera opanmälan",
                                        type: "primary",
                                        action: async () => {
                                            info.revert();
                                            await this.$store.dispatch("tabs/openTab", {
                                                component: Operationsanmalan,
                                                parameters: { id: payload.id },
                                            });
                                            resolve(null);
                                        },
                                    },
                                ],
                            });
                        });
                    } else {
                        openDialog(`Kunde inte boka operationen. ${getErrorMessage(error)}`, "error");
                        info.revert();
                        return null;
                    }
                }
            },

            eventClick(eventClickInfo) {
                eventClickInfo.jsEvent.preventDefault();

                const event = eventClickInfo.event;
                if (event.extendedProps.sparradTid) {
                    if (this.canSparraTid) this.redigeraSparradTid(event);
                } else {
                    event.setExtendedProp("showPopup", !event.extendedProps.showPopup);
                }
            },

            dateClick(dateClickInfo) {
                const events = this.calendarApi.getEvents();
                const eventsWithOpenPopups = events.filter((e) => e.extendedProps.showPopup);

                // Om det finns öppna detaljinfo-popups innebär ett klick i kalendern att de stängs.
                // Om inga popups är öppna innebär ett klick Öppna Spärra tid.
                if (eventsWithOpenPopups.length) {
                    eventsWithOpenPopups.map((e) => e.setExtendedProp("showPopup", false));
                } else if (this.canSparraTid) {
                    const starttidMoment = moment(dateClickInfo.date).startOf("hour");
                    const sparradTid = {
                        id: null,
                        datum: moment(dateClickInfo.date).format("YYYY-MM-DD"),
                        starttid: starttidMoment.format("HH:mm"),
                        sluttid: starttidMoment.add(1, "hours").format("HH:mm"),
                        sal: dateClickInfo.resource?.id !== "0" ? dateClickInfo.resource?.id : "",
                        orsak: "",
                    };
                    this.sparraTid(sparradTid);
                }
            },

            eventResize(eventResizeInfo) {
                eventResizeInfo.revert();
                if (eventResizeInfo.event.extendedProps.sparradTid) {
                    if (this.canSparraTid)
                        openDialog(
                            "För att ändra längden på en spärrad tid behöver du klicka på den och fylla i formuläret.",
                            "warning"
                        );
                } else {
                    if (this.canBokaOperation)
                        openDialog(
                            "För att ändra längden på en operation behöver du öppna och fylla i Redigera operationsanmälan.",
                            "warning"
                        );
                }
            },

            // Ett försök till att förkorta event-textens längd i tidslinjevyn med punkter, här baserat på eventets tidlängd.
            // Suboptimalt då förhållandet varierar mellan skärmstorlekar och teckenbredder, sök andra lösningar.
            truncateString(str, duration) {
                const chars = Math.floor(duration / 5 - 2);
                return str.length > chars ? str.slice(0, chars - 1) + "..." : str;
            },

            sparraTid(sparradTid = null) {
                this.sparradTid = sparradTid;
                this.showSparraTid = true;
            },

            redigeraSparradTid(event) {
                this.sparradTidEvent = event;
                const sparradTid = {
                    id: event.extendedProps.id,
                    datum: event.extendedProps.datum,
                    starttid: event.extendedProps.starttid,
                    sluttid: event.extendedProps.sluttid,
                    sal: event.extendedProps.sal.id,
                    orsak: event.extendedProps.orsak?.id ?? "",
                    kommentar: event.extendedProps.kommentar,
                };
                this.sparraTid(sparradTid);
            },

            createSparradTidEvent(newSparradTid) {
                const sparradTidEvent = createSparradTidEvent(newSparradTid);
                this.calendarApi.addEvent(sparradTidEvent);
                this.showSparraTid = false;
                this.sparradTid = null;
                flashMessage("Tid spärrad");
            },

            updateSparradTidEvent(newSparradTid) {
                this.sparradTidEvent.setDates(newSparradTid.starttid_tidpunkt, newSparradTid.sluttid_tidpunkt, false);
                this.sparradTidEvent.setResources([newSparradTid.sal]);
                this.sparradTidEvent.setExtendedProp("datum", newSparradTid.datum);
                this.sparradTidEvent.setExtendedProp("starttid", newSparradTid.starttid);
                this.sparradTidEvent.setExtendedProp("sluttid", newSparradTid.sluttid);
                this.sparradTidEvent.setExtendedProp("sal", newSparradTid.sal_display);
                this.sparradTidEvent.setExtendedProp("orsak", newSparradTid.orsak_display ?? "");
                this.sparradTidEvent.setExtendedProp("duration", newSparradTid.duration);
                this.sparradTidEvent.setExtendedProp("kommentar", newSparradTid.kommentar);

                this.showSparraTid = false;
                this.sparradTid = null;
                this.sparradTidEvent = null;
                flashMessage("Spärrad tid uppdaterad");
            },

            deleteSparradTidEvent() {
                this.showSparraTid = false;
                this.sparradTid = null;
                this.sparradTidEvent.remove();
                this.sparradTidEvent = null;
                flashMessage("Spärrad tid borttagen");
            },

            cancelSparraTid() {
                this.showSparraTid = false;
                this.sparradTid = null;
                this.sparradTidEvent = null;
            },

            setViewWithSettings(viewId) {
                const { view, hiddenDays } = this.viewLookup[viewId];
                if (hiddenDays !== this.calendarApi.getOption("hiddenDays")) {
                    this.calendarApi.setOption("hiddenDays", hiddenDays);
                }
                this.calendarApi.changeView(view);
            },
            async changeViewAndLoadData(viewId) {
                this.setViewWithSettings(viewId);

                await this.updateEntireView();
            },
            opSalView() {
                this.pickedViewOption = null;
                this.changeViewAndLoadData("opsal-view");
            },
            timelineView() {
                this.pickedViewOption = null;
                this.changeViewAndLoadData("timeline-view");
            },
            async today() {
                const today = new Date();

                if (this.pickedViewOption === "weekend-view" && ![0, 6].includes(today.getDay())) {
                    // Om jag står i helgvyn och idag inte är helg - byt till veckovyn
                    this.setViewWithSettings("week-view");
                    this.pickedViewOption = "week-view";
                } else if (this.pickedViewOption === "week-view" && [0, 6].includes(today.getDay())) {
                    // Om jag står i veckovyn och idag är en helgdag - byt till helgvyn
                    this.setViewWithSettings("weekend-view");
                    this.pickedViewOption = "weekend-view";
                }
                this.calendarApi.today();

                await this.updateEntireView();
            },
            async goToDate(date) {
                date = new Date(date);

                if (this.pickedViewOption === "weekend-view" && ![0, 6].includes(date.getDay())) {
                    // Om jag står i helgvyn och vill gå till en vardag - byt till veckovyn
                    this.setViewWithSettings("week-view");
                    this.pickedViewOption = "week-view";
                } else if (this.pickedViewOption === "week-view" && [0, 6].includes(date.getDay())) {
                    // Om jag står i veckovyn och vill gå till en helgdag - byt till helgvyn
                    this.setViewWithSettings("weekend-view");
                    this.pickedViewOption = "weekend-view";
                }

                this.calendarApi.gotoDate(date);

                await this.updateEntireView();
            },
            leaveDatePicker(date) {
                if (date) {
                    const formattedDate = moment(date).format("YYYY-MM-DD");
                    this.goToDate(formattedDate);
                }
            },

            async previous() {
                this.calendarApi.prev();

                await this.updateEntireView();
            },
            async next() {
                this.calendarApi.next();

                await this.updateEntireView();
            },

            compareIsToday_(date) {
                const today = new Date();

                return (
                    date.getDate() === today.getDate() &&
                    date.getMonth() === today.getMonth() &&
                    date.getFullYear() === today.getFullYear()
                );
            },

            async _fetchOperationsKalendar(rangeStart, rangeEnd) {
                this.filterValues = {
                    opkalender: true,
                    bokad_operation_datum__gte: rangeStart,
                    bokad_operation_datum__lte: rangeEnd,
                };

                let params = {
                    ...this.filterValues,
                    ...{
                        ordering: this.sortField,
                    },
                    limit: 100,
                    offset: 0,
                };

                return this.combineAllOperationer(
                    await klinikenApi.get("operation/kalender/", getConfig({ params })),
                    params,
                    []
                );
            },

            async combineAllOperationer(response, params, operationer) {
                const updatedOperationer = [...operationer, ...response.data.results];

                if (!response.data.next) {
                    return updatedOperationer;
                }

                const updatedParams = {
                    ...params,
                    offset: params.offset + 100,
                };

                return this.combineAllOperationer(
                    await klinikenApi.get("operation/kalender/", getConfig({ params: updatedParams })),
                    updatedParams,
                    updatedOperationer
                );
            },
            resourceIsShown(anmalan, option = this.currentFilterOption) {
                if (option === FILTER_OPTION_HUVUDOPERATORER) {
                    const operator = this.huvudoperatorer.find(
                        (operator) => operator.pk === anmalan.current_bokad_huvudoperator_display?.pk
                    );
                    if (operator && !operator.show) {
                        return false;
                    }
                } else if (option === FILTER_OPTION_LATERALITETER) {
                    const lateralitet = this.lateraliteter.find(
                        (lateralitet) => lateralitet.code === anmalan.lateralitet
                    );
                    if (lateralitet && !lateralitet.show) {
                        return false;
                    }
                } else if (option === FILTER_OPTION_ANESTESIER) {
                    const anestesiTyp = this.anestesier.find((typ) => typ.id === anmalan.current_anestesi?.id);
                    if (anestesiTyp && !anestesiTyp.show) {
                        return false;
                    }
                } else {
                    const sal = this.opsalar.find(
                        (sal) => sal.id === anmalan.bokad_sal || (sal.id == 0 && !anmalan.bokad_sal)
                    );
                    if (sal && !sal.show) {
                        return false;
                    }
                }
                return true;
            },

            getColorId(anmalan, option = this.currentFilterOption) {
                let colorId;
                if (option === FILTER_OPTION_HUVUDOPERATORER) {
                    colorId = this.findColorIdOfHuvudoperator(anmalan.current_bokad_huvudoperator_display?.pk);
                } else if (option === FILTER_OPTION_LATERALITETER) {
                    colorId = this.findColorIdOfLateralitet(anmalan.lateralitet);
                } else if (option === FILTER_OPTION_ANESTESIER) {
                    colorId = anmalan.current_anestesi?.id ?? 0;
                } else {
                    colorId = anmalan.bokad_sal ?? 0;
                }
                return colorId;
            },

            _createEvents(anmalningar = []) {
                let arr = [];
                if (isNotEmptyArray(anmalningar)) {
                    anmalningar.forEach((anmalan) => {
                        const colorId = this.getColorId(anmalan);
                        arr.push(createEvent(anmalan, colorId, this.resourceIsShown(anmalan)));
                    });
                }
                return arr;
            },
            _createSparradTidEvents(sparradeTider) {
                let arr = [];
                if (isNotEmptyArray(sparradeTider)) {
                    sparradeTider.forEach((sparradTid) => {
                        arr.push(createSparradTidEvent(sparradTid));
                    });
                }
                return arr;
            },

            formatSalstid(startParam, endParam) {
                let start;
                let end;
                if (!isNullOrUndefined(startParam)) {
                    start = moment(startParam).format("HH:mm");
                }

                if (!isNullOrUndefined(endParam)) {
                    end = moment(endParam).format("HH:mm");
                }
                return `${start ?? ""} ${end ? "- " + end : ""}`;
            },

            async bytPatient(patientId) {
                if (patientId) {
                    await this.$store.dispatch("patientData/loadFromBackend", {
                        id: patientId,
                        failSilently: false,
                    });
                }
            },

            async visaOperationsinformation(event) {
                const id = event.extendedProps.id;
                const patientId = event.extendedProps.patientId;

                await this.bytPatient(patientId);

                await this.$store.dispatch("tabs/closeTab", Operationsinformation, { root: true });
                await this.$store.dispatch("tabs/openTab", {
                    component: Operationsinformation,
                    parameters: { operationsanmalan_id: id },
                });
            },

            async visaPreanestesibedomning(event) {
                await this.bytPatient(event.extendedProps.patientId);

                await this.$store.dispatch("tabs/closeTab", PreanestesibedomningVisa, { root: true });

                await this.$store.dispatch("tabs/openTab", {
                    component: PreanestesibedomningVisa,
                    parameters: {
                        operationsanmalanId: event.extendedProps.id,
                        preanestesibedomningId: event.extendedProps.aktuellPreanestesibedomning,
                        showPreanestesibedomning: true,
                    },
                });
            },

            async skapaKallelse(event) {
                const id = event.extendedProps.id;
                const patientId = event.extendedProps.patientId;

                try {
                    await this.bytPatient(patientId);

                    const response = await klinikenApi.get(`operation/anmalan/${id}`, getConfig());
                    const anmalan = response.data;
                    await this.$store.dispatch("tabs/closeTab", KallelseSend, { root: true });
                    await this.$store.dispatch("tabs/openTab", {
                        component: KallelseSend,
                        parameters: { receiver: anmalan, baseUrl: "/operation/anmalan/", path: "/kallelse/" },
                    });
                } catch (e) {
                    openDialog(`Kunde inte skapa kallelse. ${getErrorMessage(e)}`, "error");
                }
            },

            async redigeraBokning(event) {
                const id = event.extendedProps.id;
                const patientId = event.extendedProps.patientId;

                try {
                    await this.bytPatient(patientId);

                    const response = await klinikenApi.get(`operation/anmalan/${id}`, getConfig());
                    const anmalan = response.data;
                    const operatorer = await fetchData({
                        url: "/core/profiles/",
                        params: { operator: true },
                    });
                    dialogEvents.$emit("openPopup", {
                        title: anmalan.status !== "Bokad" ? "Boka operation" : "Redigera bokning",
                        component: BokaOperation,
                        dismissable: false,
                        data: {
                            listItem: anmalan,
                            operatorer: operatorer,
                            preliminarbokningLocked: preliminarbokningLocked(anmalan),
                        },
                    });
                } catch (error) {
                    openDialog(`Kunde inte boka om operationen. ${getErrorMessage(error)}`, "error");
                }
            },
            async avbokaOperation(event) {
                const id = event.extendedProps.id;
                const patientId = event.extendedProps.patientId;

                try {
                    await this.bytPatient(patientId);

                    const response = await klinikenApi.get(`operation/anmalan/${id}`, getConfig());
                    const anmalan = response.data;
                    const strykningsorsaker = await fetchData({
                        url: "/operation/kodverk/strykningsorsaker/",
                    });
                    this.$emit("closePopup");
                    dialogEvents.$emit("openPopup", {
                        title: "Avboka eller Stryk",
                        component: AvbokaOperation,
                        dismissable: false,
                        data: {
                            listItem: anmalan,
                            strykningsorsaker,
                        },
                        allowScroll: true,
                    });
                } catch (error) {
                    openDialog(`Kunde inte avboka operationen. ${getErrorMessage(error)}`, "error");
                }
            },
            taBortPreliminarbokning(event) {
                this.taBortPreliminarbokningById(event.extendedProps.id);
            },
            async updateEvent(anmalan) {
                const event = this.calendarApi
                    .getEvents()
                    .find((e) => !e.extendedProps.sparradTid && e.extendedProps.id === anmalan.id);
                if (event) {
                    const colorId = this.getColorId(anmalan);
                    setEventInfo(event, anmalan, colorId, false);
                    this.resetFiltering();
                } else {
                    const colorId = this.getColorId(anmalan);
                    const newEvent = createEvent(anmalan, colorId);
                    this.calendarApi.addEvent(newEvent);
                    this.resetFiltering();
                }

                this.refreshResources();
            },
            getCurrentRange() {
                const currentViewType = this.calendarApi.currentData.currentViewType;
                const activeStart = this.calendarApi.currentData.dateProfile.activeRange.start;
                const activeEnd = this.calendarApi.currentData.dateProfile.activeRange.end;
                let dates;

                if (["resourceTimeGridWeek", "timeGridWeek"].includes(currentViewType)) {
                    dates = {
                        start: moment(activeStart).startOf("week"),
                        end: moment(activeStart).endOf("week"),
                    };
                } else if (currentViewType === "dayGridMonth") {
                    dates = {
                        start: moment(activeStart),
                        end: moment(activeEnd).subtract(1, "days"),
                    };
                } else {
                    dates = {
                        start: moment(activeStart).startOf("day"),
                        end: moment(activeStart).endOf("day"),
                    };
                }

                return {
                    start: dates.start.format("YYYY-MM-DD"),
                    end: dates.end.format("YYYY-MM-DD"),
                };
            },
            async refreshResources() {
                const range = this.getCurrentRange();

                try {
                    const { data } = await klinikenApi.get(
                        "operation/anmalanresurs",
                        getConfig({
                            params: {
                                start_date: range.start,
                                end_date: range.end,
                            },
                        })
                    );

                    Object.entries(Object.groupBy(data.results, ({ anmalan }) => anmalan)).forEach(
                        ([anmalanId, resurser]) => {
                            const event = this.calendarApi.getEventById(anmalanId);
                            if (event) {
                                const resurskrockar = resurser.reduce((krockar = [], resurs) => {
                                    if (resurs.krock) {
                                        return [...krockar, resurs.resurs_display];
                                    }

                                    return krockar;
                                }, []);

                                event.setExtendedProp("resurskrockar", resurskrockar);
                            }
                        }
                    );
                } catch (error) {
                    openDialog(
                        "Kunde inte hämta senaste informationen om resurser. Du behöver stänga ner och öppna Operationskalendern igen",
                        "warning"
                    );
                }
            },
            async loadEventsForCurrentView() {
                const range = this.getCurrentRange();

                try {
                    await this.$store.dispatch("tabs/displaySpinner", { id: this.tabId, display: true });

                    const anmalningar = await this._fetchOperationsKalendar(range.start, range.end);

                    const response = await klinikenApi.get(
                        "/operation/sparradtid/",
                        getConfig({
                            params: { datum__gte: range.start, datum__lte: range.end },
                        })
                    );
                    const sparradeTider = response.data.results;

                    let events = this._createEvents(anmalningar);
                    let sparradTidEvents = this._createSparradTidEvents(sparradeTider);
                    events = events.concat(sparradTidEvents);

                    this.$set(this.calendarOptions, "events", events);
                    this.allDayEvents = events.filter((event) => event.allDay);
                } catch (_) {
                    openDialog("Kunde inte hämta operationer till kalendern", "error");
                } finally {
                    await this.$store.dispatch("tabs/displaySpinner", { id: this.tabId, display: false });
                }
            },
            createEventData(event) {
                // TODO: Den saknar en massa settings, varför funkar den?
                return {
                    title: "",
                    id: event.extendedProps.id,
                    huvudoperator: event.extendedProps.huvudoperator?.pk,
                    duration:
                        `${Math.floor(event.extendedProps.salstid / 60)}`.padStart(2, "0") +
                        ":" +
                        `${event.extendedProps.salstid % 60}`.padStart(2, "0"),
                    forberedelser: event.extendedProps.forberedelser,
                    optid: event.extendedProps.optid,
                    salstid: event.extendedProps.salstid,
                    avveckling: event.extendedProps.avveckling,
                    installelsedatum: event.extendedProps.installelsedatum,
                };
            },
            async savePlanerad() {
                this.dagsinformation = { ...this.dagsinformation, planerad: this.planerad };

                if (this.dagsinformation.id) {
                    const response = await klinikenApi.patch(
                        `/operation/dagsinformation/${this.dagsinformation.datum}/`,
                        { planerad: this.planerad },
                        getConfig()
                    );
                    this.dagsinformation = response.data;
                } else {
                    const response = await klinikenApi.post(
                        "/operation/dagsinformation/",
                        this.dagsinformation,
                        getConfig()
                    );
                    this.dagsinformation = response.data;
                }
            },

            async submitKommentar(kommentar) {
                this.showKommentera = false;
                if (kommentar !== null) {
                    this.dagsinformation = { ...this.dagsinformation, kommentar };
                    if (this.dagsinformation.id) {
                        const response = await klinikenApi.patch(
                            `/operation/dagsinformation/${this.dagsinformation.datum}/`,
                            { kommentar: kommentar },
                            getConfig()
                        );
                        this.dagsinformation = response.data;
                    } else {
                        const response = await klinikenApi.post(
                            "/operation/dagsinformation/",
                            this.dagsinformation,
                            getConfig()
                        );
                        this.dagsinformation = response.data;
                    }
                }
            },

            async loadDagsinformation() {
                const currentDate = moment(this.calendarApi.currentData.dateProfile.currentDate).format("YYYY-MM-DD");

                try {
                    const response = await klinikenApi.get(`/operation/dagsinformation/${currentDate}/`, getConfig());
                    if (response.data) {
                        this.dagsinformation = response.data;
                    } else {
                        this.dagsinformation = { datum: currentDate, planerad: false };
                    }
                } catch (e) {
                    this.dagsinformation = { datum: currentDate, planerad: false };
                }
                this.planerad = this.dagsinformation.planerad;
            },

            getKommentarOrOrsak(event) {
                if (event.extendedProps.kommentar && event.extendedProps.kommentar.length > 0) {
                    return event.extendedProps.kommentar;
                } else {
                    return event.extendedProps.orsak?.namn;
                }
            },

            async fetchAndSetSalsbemanningList() {
                const salsbemanningResponse = await klinikenApi.get(
                    `/operation/salsbemanning/`,
                    getConfig({
                        params: {
                            datum: moment(this.getViewDate).format("YYYY-MM-DD"),
                        },
                    })
                );
                this.salsbemanningList = salsbemanningResponse?.data?.results ?? [];
            },

            updateSalsbemanningOnResource(resource) {
                resource.salsbemanning = this.salsbemanningList.find((item) => item.sal == resource.id) ?? {
                    id: null,
                    sal: resource.id,
                    sal_display: {
                        id: resource.id,
                        namn: resource.namn,
                        ordning: resource.ordning,
                        org_units: resource.org_units,
                        orgunits_display: resource.orgunits_display,
                    },
                    datum: moment(this.getViewDate).format("YYYY-MM-DD"),
                    personal: [],
                    handelser: [],
                    kommentar: null,
                };
                return resource;
            },

            setAllResourcesSalsbemanning() {
                const resources = this.calendarOptions.resources.map((resource) => {
                    return this.updateSalsbemanningOnResource(resource);
                });
                this.$set(this.calendarOptions, "resources", resources);
            },

            async updateEntireView() {
                await this.fetchAndSetSalsbemanningList();
                this.setAllResourcesSalsbemanning();
                await this.loadEventsForCurrentView();
                await this.loadDagsinformation();
            },

            openPersonalOchTider(salsbemanning) {
                this.salsbemanning = salsbemanning;
                this.showPersonalOchTider = true;
            },
            closePersonalOchTider() {
                this.showPersonalOchTider = false;
                this.salsbemanning = null;
            },
            personalOchTiderSubmitted(newSalsbemanning) {
                // Uppdaterar eller lägger till salsbemanningen
                const index = this.salsbemanningList.findIndex((item) => item.id === newSalsbemanning.id);
                if (index !== -1) {
                    this.salsbemanningList[index] = newSalsbemanning;
                } else {
                    this.salsbemanningList.push(newSalsbemanning);
                }

                // Uppdaterar alla salar med aktuell salsbemanning
                this.setAllResourcesSalsbemanning();

                this.closePersonalOchTider();
            },
            onOperationsanmalanAvbokad: ({ id, status, calendarApi }) => {
                const event = calendarApi
                    .getEvents()
                    .find((e) => !e.extendedProps.sparradTid && e.extendedProps.id === id);
                if (event) {
                    if ((status && status === "Avbokad") || status === "Struken") {
                        event.remove();
                    }
                }
            },
        },

        async mounted() {
            this.canReadOperationskalender = this.can({ action: "read", subject: "operationskalender" });

            if (!this.canReadOperationskalender) {
                // TODO: Varningsmeddelande - vilket ska användas?
                await this.$store.dispatch("tabs/closeTab", this.tabId);
                return;
            }

            this.canReadAnmalan = this.can({ action: "read", subject: "anmalan" });
            this.canReadPeranestesibedomning = this.can({ action: "read", subject: "preanestesibedomning" });
            this.canBokaOperation = this.can({ action: "boka", subject: "anmalan" });
            this.canAvbokaOperation = this.can({ action: "avboka", subject: "anmalan" });
            this.canUpdateDagsinformation = this.can({ action: "update", subject: "dagsinformation" });
            this.canSparraTid = this.can({ action: "update", subject: "sparradtid" });
            this.canSkapaKallelse = this.can({ action: "kallelse", subject: "anmalan" });

            this.calendarApi = await this.$refs.fullCalendar.getApi();

            await this.loadEventsForCurrentView();

            await this.loadDagsinformation();

            this.eventColorScheme = eventColorScheme;

            let resources = [
                {
                    id: 0,
                    namn: "Ingen Opsal",
                    ordning: -1,
                    backgroundColor: BG_COLOR_NEUTRAL,
                    textColor: TEXT_COLOR_NEUTRAL,
                },
            ];
            let salar = await fetchData({
                url: "/operation/salar/",
            });
            salar = this.configureResourceGroupColors(salar);
            resources = resources.concat(salar);

            // Hämtar salsbemanning
            await this.fetchAndSetSalsbemanningList();

            resources = resources.map((resource) => {
                resource = this.updateSalsbemanningOnResource(resource);
                resource.title = resource.namn;
                resource.show = true;
                return resource;
            });
            this.$set(this.calendarOptions, "resources", resources);
            this.opsalar = [...resources];
            let operatorer = await fetchData({
                url: "/core/profiles/",
                params: { operator: true, is_active: true },
            });
            let operatorList = operatorer.map((operator, index) => ({
                id: index + 1,
                pk: operator.pk,
                title: operator.user_display?.name ?? "",
                show: true,
            }));
            operatorList = this.configureResourceGroupColors(operatorList);
            this.huvudoperatorer = operatorList;

            this.lateraliteter = this.configureResourceGroupColors(this.lateraliteter);

            await this.$store.dispatch("operation/anestesi/fetchAnestesi", {
                displayMode: true,
            });
            const anestesiData = this.$store.getters["operation/anestesi/anestesiSubset"]({
                displayMode: true,
            });
            let anestesier = anestesiData?.length
                ? anestesiData.map((anestesiType) => ({
                      id: anestesiType.value,
                      is_blockad: anestesiType.is_blockad,
                      title: anestesiType.label,
                      show: true,
                  }))
                : [];
            this.anestesier = this.configureResourceGroupColors(anestesier);

            emitter.on("operationsanmalan-uppdaterad", this.updateEvent);
            emitter.on("operationsanmalan-bokad", this.updateEvent);
            emitter.on("operationsanmalan-avbokad", (props) =>
                this.onOperationsanmalanAvbokad({
                    calendarApi: this.calendarApi,
                    ...props,
                })
            );
            emitter.on(`adjust-tab-${this.$options.tabName}`, async () => {
                setTimeout(() => {
                    this.calendarApi.updateSize();
                }, 10);
            });
            emitter.on(`refreshTab-${this.tabId}`, async () => {
                await this.updateEntireView();
            });
        },

        beforeDestroy() {
            emitter.off("operationsanmalan-uppdaterad", this.updateEvent);
            emitter.off("operationsanmalan-bokad", this.updateEvent);
            emitter.off("operationsanmalan-avbokad", (props) =>
                this.onOperationsanmalanAvbokad({
                    calendarApi: this.calendarApi,
                    ...props,
                })
            );
            emitter.off(`adjust-tab-${this.$options.tabName}`);
            emitter.off(`refreshTab-${this.tabId}`);
        },
    };
</script>

<style lang="scss">
    @import "@/style/_variables.scss";

    $gap: 1rem;
    $padding: 0.4rem;

    .operationskalender {
        $event-color-neutral: #7dbfd7;
        display: flex;
        gap: 46px;

        .page-wrapper {
            .header-section {
                display: flex;
                justify-content: space-between;

                h2 {
                    &::first-letter {
                        text-transform: capitalize;
                    }
                }

                .header-section-left {
                    display: flex;
                    flex-direction: row-reverse;
                    flex-wrap: wrap;
                    gap: 20px;

                    .dagsinformation {
                        height: 56px;
                        width: 320px;
                        background-color: #fafbfd;
                        border: solid 1px #e4e8f0;
                        border-radius: 4px;
                        display: flex;
                        align-items: center;
                        padding: 16px 24px;
                        gap: 16px;

                        .formulate-input {
                            margin: 10px 0 0 0;

                            &[data-has-value="true"] {
                                .formulate-input-element-decorator {
                                    background-color: #2d9367;
                                }
                            }

                            .formulate-input-element-decorator {
                                height: 18px;
                                width: 18px;
                            }
                        }

                        span {
                            font-size: 14px;
                        }

                        label {
                            font-size: 14px;
                            color: #354052 !important;
                            margin-top: -3px;
                        }

                        hr {
                            border: none;
                            border-left: 1px solid #b9d8e3;
                            height: 40px;
                            width: 1px;
                        }
                    }

                    .k3-calendar-toolbar {
                        background-color: #ebf6f8;
                        height: fit-content;
                        border-radius: 4px;
                        display: grid;
                        gap: $gap;
                        align-items: center;
                        grid-auto-flow: column;
                        grid-auto-columns: max-content;
                        padding: 0 0.6rem;

                        .datepicker {
                            margin: 0;
                            width: 8rem;
                            height: 32px;
                            margin-left: 0.5rem;

                            .formulate-input-wrapper,
                            .formulate-input-element,
                            .formulate-input-element > div,
                            .mx-datepicker,
                            .mx-input-wrapper {
                                height: inherit;
                            }

                            input {
                                font-size: 14px;
                                height: 100%;
                                padding-top: 0;
                                padding-bottom: 0;
                            }
                        }

                        .calendar-view {
                            height: 100%;

                            .formulate-input-wrapper,
                            .formulate-input-element {
                                height: inherit;
                            }

                            select {
                                height: 100%;
                                width: fit-content;
                                font-size: 14px;
                                border: none;
                                border-radius: unset;
                                background: transparent;
                                padding: 0;
                                padding-right: 1rem;
                                color: #3092b5;
                                text-align: center;
                                background: url("@/assets/arrow_down.svg") no-repeat right center !important;
                                cursor: pointer;
                            }
                        }

                        .sparra-tid-tab {
                            margin-right: $gap;
                        }

                        .tab-button-left {
                            display: grid;
                            grid-auto-flow: column;
                            gap: 0.3rem;
                            background: none;
                            border: none;
                            font-size: 14px;
                            color: #55676d;
                        }

                        .view-button {
                            background: none;
                            border: none;
                            font-size: 14px;
                            color: #3092b5;
                        }

                        .view-button,
                        .tab-button-left {
                            box-sizing: border-box;
                            padding: 1.2rem 0;
                        }

                        .active-tab {
                            font-weight: bold;
                            text-decoration: underline;
                            text-decoration-thickness: 3px;
                            text-underline-offset: 12px;
                        }

                        .arrow-buttons {
                            display: flex;
                            gap: $gap;
                        }

                        .arrow-button {
                            display: grid;
                            place-items: center;
                            background: #38a7cf;
                            border: none;
                            padding: 2px 6px;
                            border-radius: 4px;
                            width: 30px;
                            height: 30px;
                            color: #fafbfd;
                            box-sizing: border-box;
                        }
                    }
                }
            }
        }

        .fc-scrollgrid {
            border: none !important;
        }

        tr.fc-scrollgrid-section-header {
            th {
                border-left: none;
                border-right: none;
                border-top: none;
            }
        }

        .fc-timegrid-slot-minor {
            border-top: none !important;
            border-top-style: none !important;
        }

        tr.fc-scrollgrid-section {
            height: 0;

            td.fc-timegrid-divider {
                padding: 0;
            }
        }

        .fc-event {
            border: none;
            border-radius: 4px;
            height: 100%;
        }

        .fc-event-main {
            height: 100%;
        }

        .v-popper {
            height: 100%;
            width: 100%;
        }

        .date-text {
            margin-bottom: 20px;
        }

        .calendar-info {
            font-size: 14px;
        }

        .header-title {
            font-size: 14px;
            display: flex;
            gap: 1rem;
        }

        .timeline-all-day-info {
            margin-bottom: 14px;
            background-color: $color-background-tool-menu;
            padding: $padding * 2 $padding;
            padding-top: $padding / 2;

            > div {
                display: flex;
                flex-wrap: wrap;
                gap: $gap;
            }

            > p {
                font-size: 12px;
                padding-bottom: $padding;
            }

            .k3-custom-event-info {
                display: flex;
                justify-content: space-between;
                gap: 0.5rem;
            }
        }

        // Gäller enbart Dagens operationer
        .all-day-cell {
            font-size: 10.5px;
            line-height: 13px;

            div {
                background-color: #f6f8fb;
            }
        }

        .all-day-cell ~ .fc-day {
            height: 100%;

            .fc-daygrid-day-frame {
                background-color: #f6f8fb;
                height: 100%;

                .fc-daygrid-day-events {
                    height: 100%;

                    .fc-daygrid-event-harness {
                        height: 40px;

                        .fc-event {
                            height: 30px;
                            margin: 10px;

                            .k3-custom-event-info {
                                top: 4px;
                            }
                        }
                    }
                }
            }
        }

        .fc-scrollgrid-section {
            th {
                background-color: #ffffff !important;
            }
        }

        // Textfärg i table headers
        *:is(.fc-col-header-cell-cushion, .fc-timegrid-axis-cushion, .fc-timeline-slot-cushion) {
            color: #55676d;

            &:hover {
                text-decoration: none;
            }
        }

        // Gäller enbart tidslinjevyn
        .fc-resourceTimelineDay-view {
            // Döljer veckonummer
            .fc-timeline-header-row:not(.fc-timeline-header-row-chrono) {
                th {
                    border-bottom: none;

                    a {
                        display: none;
                    }
                }
            }

            .fc-resource-timeline-divider {
                width: 0;
            }

            tr.fc-scrollgrid-section-header {
                .fc-resource-timeline-divider {
                    border: none;
                }
            }

            .all-day-event {
                display: none;
            }

            .fc-timeline-lane {
                min-height: 5rem;

                .fc-timeline-lane-frame {
                    min-height: 5rem;
                }
            }

            .resource-label-cell {
                width: 100%;

                .fc-datagrid-cell-frame {
                    min-height: 5rem;
                    display: flex;
                    flex-direction: row;
                    align-items: center;

                    .color-mark {
                        background-color: #93c9de;
                        min-width: 7px;
                        min-height: 28px;
                        border-radius: 4px;
                        margin-left: 9px;
                    }
                    .fc-datagrid-cell-cushion {
                        width: 100%;

                        .timeline-resource-wrapper {
                            display: flex;
                            align-items: center;
                            position: relative;

                            .edit-salsbemanning {
                                position: absolute;
                                right: 0;
                                top: 0;
                                padding: 0 0 0.25rem 0.25rem;
                                width: 1.25rem;
                                background-color: #ffffff;
                            }

                            .resource-header {
                                min-width: 5rem;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: pre;

                                > * {
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: pre;
                                }
                            }

                            .box {
                                background-color: $color-background-tool-menu;
                                border-radius: 0.355rem;
                                padding: 0.313rem;
                            }

                            .salsbemanning {
                                min-height: 4rem;

                                .personal {
                                    display: flex;
                                    gap: 0.25rem;
                                    width: fit-content;

                                    &.kirurg {
                                        font-family: "Roboto Medium";
                                    }

                                    .personal-icon {
                                        height: 1.325rem;
                                        width: 1.325rem;
                                    }

                                    .personal-name {
                                        font-size: 0.625rem;
                                        line-height: 0.75rem;
                                    }

                                    .personal-time {
                                        font-size: 0.5rem;
                                        line-height: 0.625rem;
                                    }
                                }
                            }

                            > * {
                                max-width: 100%;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: pre;
                            }

                            .salsbemanning-kommentar {
                                margin-top: 0.438rem;
                                width: fit-content;
                                padding: 0.375rem 0.5rem;
                                font-size: 0.625rem;
                                line-height: 0.875rem;
                                max-width: 100%;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: pre;
                            }
                        }
                    }
                }
            }

            .fc-timeline-event-harness {
                box-sizing: border-box;
                height: 30px;
                top: 5px !important;

                .fc-event {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding: 0;

                    .k3-custom-event-container {
                        .k3-custom-event-info {
                            display: flex;
                            justify-content: space-between;
                            gap: 0.5rem;
                        }

                        .k3-custom-event-background {
                            min-height: 30px;
                            display: flex;
                            flex-direction: row;
                            height: 100%;
                            width: 100%;
                            position: relative;
                            top: 0;
                            margin-left: 0;

                            .k3-custom-event-forberedelser {
                                width: 100%;
                                background-color: white;
                                opacity: 0.8;
                                margin-left: 0;
                            }

                            .k3-custom-event-optid {
                                background-color: white;
                                opacity: 0.6;
                                margin-left: 0;
                            }

                            .k3-custom-event-avveckling {
                                width: 100%;
                                background-color: white;
                                opacity: 0.8;
                                margin-left: 0;
                            }
                        }
                    }
                }

                .all-day {
                    display: none !important;
                }
            }
        }

        // Gäller enbart månadsvyn
        .fc-dayGridMonth-view {
            .fc-event {
                margin: 0 6px;
            }

            .fc-daygrid-dot-event {
                padding: 0;
            }

            .fc-daygrid-day-events {
                display: flex;
                flex-direction: column;
                gap: 6px;
            }
        }

        // Generellt för alla events
        .fc-event {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            position: relative;
        }

        .stripes-overlay {
            position: absolute;
            background: repeating-linear-gradient(-45deg, #ffffff, #ffffff 2px, transparent 2px, transparent 7px);
            z-index: 1001;
            width: 100%;
            height: 100%;
        }

        .k3-custom-event-container {
            box-sizing: border-box;
            height: 100%;
            width: 100%;
            position: relative;

            .k3-custom-event-info {
                position: absolute;
                top: 5px;
                padding: 0 8px 0 12px;
                color: #37809b;
                z-index: 1002;
                width: 100%;

                .info-group {
                    display: flex;
                    gap: 10px;
                }

                .k3-custom-event-time-user {
                    margin-top: 4px;
                    display: flex;
                    justify-content: space-between;
                    gap: 0.5rem;
                }

                .k3-custom-event-opkod-personid {
                    display: flex;
                    justify-content: space-between;
                    gap: 0.5rem;
                }

                .resource-error {
                    position: absolute;
                    top: -3px;
                    right: 2px;
                }
            }

            &.event-tiny {
                .k3-custom-event-info {
                    top: 2px;
                }

                .k3-custom-event-optid {
                    position: relative;
                    height: 105%;
                    border-radius: 0 4px 4px 0;
                    background-color: #d4eaf2;
                }
            }

            .resource-error {
                position: sticky;
                right: 0;
                display: grid;
                padding-left: 2px;

                > img {
                    height: 10px;
                    width: 10px;
                }
            }

            // Visas i månadsvy - starttid och personnummer
            &.event-nano {
                width: 100%;
                padding: 2px 8px 2px 12px;
                border-radius: 4px;
                color: white;
                position: relative;
                top: 0px;

                span {
                    z-index: 1000;
                }

                .resource-error {
                    margin-right: -7px;
                }

                .event-info-month {
                    display: grid;
                    grid-auto-flow: column;
                    grid-template-columns: 1fr auto;
                }

                .k3-custom-event-background {
                    position: absolute;
                    top: 0;
                    margin: 0;
                    left: 0;
                    z-index: 999;
                    min-height: 26px !important;
                    width: 100%;

                    .k3-custom-event-optid {
                        width: 100%;
                        background-color: white;
                        opacity: 0.6;
                    }
                }
            }

            // Avnänds just nu enbart i månads- och tidslinjevyn, som barn till .k3-custom-event-background
            .event-stripe {
                position: absolute;
                z-index: 1000;
                height: 100%;
                min-width: 6px;
                background-color: $event-color-neutral;
                border-radius: 4px;
            }
        }

        // Gäller alla vyer utom tidslinjen
        .event-standard-pattern {
            .k3-custom-event-background {
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                height: 100%;
                width: 99.5%;
                position: relative;
                top: -1px;
                margin-left: 5px;

                .k3-custom-event-forberedelser {
                    width: 100%;
                    background-color: white;
                    opacity: 0.8;
                }

                .k3-custom-event-optid {
                    width: 100%;
                    background-color: white;
                    opacity: 0.6;
                }

                .k3-custom-event-avveckling {
                    width: 100%;
                    background-color: white;
                    opacity: 0.8;
                }
            }
        }

        // Spärrade tider
        .sparrad-tid-event {
            background: repeating-linear-gradient(-45deg, #ffffff, #ffffff 1px, #e9ecec 1px, #e9ecec 7px);

            span {
                color: #6c8188;
            }

            .sparrad-tid-time-full {
                margin: 9px 16px 0 16px;
                font-size: 16px;
                font-weight: 500;
            }

            .sparrad-tid-info {
                display: flex;
                justify-content: space-between;
                gap: 0.5rem;
                font-size: 14px;
            }

            .sparrad-tid-info-nano {
                width: 100%;
                margin: 2px 12px 2px 12px;
            }

            .sparrad-tid-info-tiny {
                margin: 1px 16px 1px 16px;
            }

            .sparrad-tid-info-small {
                margin: 9px 16px 9px 16px;
            }

            .sparrad-tid-info-full {
                margin: 6px 16px 6px 16px;
            }

            .sparrad-tid-info-timeline {
                margin: 4px 10px 4px 10px;
            }
        }

        .fc-timegrid-col-events {
            margin-right: 2px;
        }

        .fc-timegrid-now-indicator-line {
            border-color: #ca346f;
        }

        .fc-day-today {
            background: transparent !important;
        }

        .hidden-event {
            display: none;
        }

        .sidebar-div {
            z-index: 199;
            min-height: 100%;
            min-width: 250px;
            background-color: #f9fbfe;
            border-right: 1px solid #d3d8da;
        }

        .calendar-container {
            width: 100%;
        }

        .close-sidebar-row {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            margin-top: 14px;
            margin-right: 14px;
        }

        .sidebar-section {
            margin-top: 1.75rem;
            margin-left: 28px;
            margin-right: 17px;

            .section-title {
                margin-left: 5px;
                text-transform: uppercase;
                font-size: 11px;
                line-height: 16.5px;
                color: #6c8188;
            }
        }

        .sidebar-title {
            margin-left: 5px;
            text-transform: uppercase;
            font-size: 14px;
            line-height: 16.5px;
            color: #55676d;
        }

        label.filter-option {
            position: relative;

            input {
                appearance: none;
            }

            input:not(:checked) + div.checkbox-frame {
                img {
                    display: none;
                }
            }

            div.checkbox-frame {
                position: absolute;
                top: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 18px;
                height: 18px;
                border: #65767c 1px solid;
                border-radius: 4px;
            }

            span {
                position: absolute;
                top: 2px;
                left: 20px;
            }
        }

        label.filter-resource-option {
            position: relative;
            display: block;
            margin: 16px 0 12px 0;

            input {
                appearance: none;
            }

            input:not(:checked) + div.checkbox-frame {
                background-color: transparent !important;

                img {
                    display: none;
                }
            }

            input:hover + div.checkbox-frame {
                filter: brightness(90%);
            }

            input:active + div.checkbox-frame {
                filter: brightness(80%);
            }

            div.checkbox-frame {
                position: absolute;
                top: 0;

                display: flex;
                align-items: center;
                justify-content: center;
                width: 18px;
                height: 18px;
                border: #65767c 1px solid;
                border-radius: 4px;
            }

            img {
                z-index: 1000;
            }

            span {
                position: absolute;
                left: 26px;
            }
        }

        .close-sidebar-icon {
            height: 12px;
            width: 12px;
            cursor: pointer;
        }

        .sidebar-divider {
            height: 1px;
            border: none;
            background-color: #d3d8da;
        }
    }
</style>
